import { FC } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { Button } from 'portfolio3/ui-kit/button';
import PopUp from 'portfolio3/ui-kit/modals/PopUp';

import { industryIllustrations } from '../../assets';
import * as styles from './styles';

interface IProforientationResultsPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onAction: () => void;
}

const ProforientationResultsPopup: FC<IProforientationResultsPopupProps> = ({ isOpen, onClose, onAction }) => {
  const bodyElement = (
    <Stack className="proforientationResultsBody" direction="row" sx={styles.popupBody}>
      <Stack gap="8px">
        <Typography variant="Headings/H5" sx={styles.popupTypography}>
          Готовы результаты профориентации!
        </Typography>
        <Typography variant="Paragraph LG/Regular" sx={styles.popupTypography}>
          Ознакомься с результатами и скачай их
        </Typography>
      </Stack>
      <Box component="img" sx={styles.popupImg} src={industryIllustrations.проф_тестирование} alt="profTestingImage" />
    </Stack>
  );

  const closeButtonElement = (
    <Button variant="secondary" size="large" onClick={onClose}>
      Закрыть
    </Button>
  );

  const actionButtonElement = (
    <Button size="large" onClick={onAction}>
      Перейти к результатам
    </Button>
  );

  return (
    <PopUp
      size="small"
      open={isOpen}
      title="Результаты профориентации"
      onClose={onClose}
      body={bodyElement}
      bodySx={styles.popupInnerBody}
      rightAdditionalButton={closeButtonElement}
      rightMainButton={actionButtonElement}
    />
  );
};

export default ProforientationResultsPopup;
